import { queryOptions } from '@tanstack/react-query';
import type { MeDto } from '@ultrasnip/contracts';
import { api } from './api-client';

/** Central query keys: every cache entry is addressed through here. */
export const QueryKeys = {
  me: ['me'] as const,
  sessions: ['auth', 'sessions'] as const,
};

export const meQuery = queryOptions({
  queryKey: QueryKeys.me,
  queryFn: ({ signal }) => api.get<MeDto>('/me', { signal }),
  staleTime: 60_000,
});

/** SOL/USD for USD figures (market caps, values). */
export const solUsdQuery = queryOptions({
  queryKey: ['sol-usd'] as const,
  queryFn: ({ signal }) => api.get<{ usd: number | null }>('/tokens/sol-usd', { signal }),
  staleTime: 30_000,
  refetchInterval: 60_000,
  select: (data) => data.usd,
});
